/**
 * Slideshow Video Slide Playback Controller
 * Handles autoplay, pause on slide change, desktop/mobile visibility, and iOS low-power mode.
 */
(function() {
  function removeLoading(video) {
    if (!video) return;
    var player = video.closest('.video__player') || video.closest('video-background');
    if (player) {
      player.classList.remove('is-loading');
    }
  }

  function getVisibleVideo(slide) {
    var videos = slide.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      var player = v.closest('.video__player') || v.closest('video-background');
      var isPlayerVisible = !player || window.getComputedStyle(player).display !== 'none';
      if (isPlayerVisible && (v.offsetWidth > 0 || v.offsetHeight > 0 || v.getClientRects().length > 0 || v.offsetParent !== null)) {
        return v;
      }
    }
    return null;
  }

  function ensureVideoLoaded(slide) {
    var videoBgs = slide.querySelectorAll('video-background');
    videoBgs.forEach(function(videoBg) {
      if (window.getComputedStyle(videoBg).display !== 'none' && !videoBg.querySelector('video')) {
        var tmpl = videoBg.querySelector('template[data-video-template]');
        if (tmpl) {
          videoBg.innerHTML = tmpl.innerHTML;
        }
      }
    });
  }

  function updateSlidePlayback(slideshow) {
    var slides = slideshow.querySelectorAll('.slideshow__slide');
    slides.forEach(function(slide) {
      var isSelected = slide.classList.contains('is-selected');
      if (isSelected) {
        ensureVideoLoaded(slide);
        var activeVideo = getVisibleVideo(slide);
        if (activeVideo) {
          if (activeVideo.readyState >= 2 || !activeVideo.paused) {
            removeLoading(activeVideo);
          } else {
            activeVideo.addEventListener('playing', function onPlaying() {
              removeLoading(activeVideo);
              activeVideo.removeEventListener('playing', onPlaying);
            });
          }

          if (activeVideo.paused) {
            var playPromise = activeVideo.play();
            if (playPromise !== undefined) {
              playPromise.then(function() {
                removeLoading(activeVideo);
              }).catch(function() {});
            }
          }
        }
      } else {
        var videos = slide.querySelectorAll('video');
        videos.forEach(function(v) {
          if (!v.paused) {
            v.pause();
          }
        });
      }
    });
  }

  function initSlideshow(section) {
    if (!section || section.dataset.slideshowVideoInit === 'true') return;
    section.dataset.slideshowVideoInit = 'true';

    updateSlidePlayback(section);

    var slides = section.querySelectorAll('.slideshow__slide');
    if (window.MutationObserver) {
      var observer = new MutationObserver(function(mutations) {
        var needsUpdate = false;
        mutations.forEach(function(m) {
          if (m.type === 'attributes' && m.attributeName === 'class') {
            needsUpdate = true;
          }
        });
        if (needsUpdate) {
          updateSlidePlayback(section);
        }
      });

      slides.forEach(function(slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }

    section.addEventListener('theme:slider:loaded', function() {
      updateSlidePlayback(section);
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        updateSlidePlayback(section);
      }, 150);
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-section-type="slideshow"]');
    sections.forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target) {
      var section = e.target.matches && e.target.matches('[data-section-type="slideshow"]') ? e.target : e.target.querySelector('[data-section-type="slideshow"]');
      if (section) {
        delete section.dataset.slideshowVideoInit;
        initSlideshow(section);
      }
    }
  });
})();
